// extracted by mini-css-extract-plugin
export default {"root":"Paper_root__qZ4Sd"};